import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKxLvmSapBuExportStatus: 'idle',
    startProcessKxLvmSapBuExportError: undefined as any,
    loadUserParamsProcessKxLvmSapBuExportStatus: 'idle',
    loadUserParamsProcessKxLvmSapBuExportError: undefined as any,

    processKxLvmSapBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKxLvmSapBuExport = createAsyncThunk('processKxLvmSapBuExportSlice/startProcessKxLvmSapBuExport', async ({ processKxLvmSapBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKxLvmSapBuExport/`,
        prepareData(processKxLvmSapBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKxLvmSapBuExportStatus } = getState().processKxLvmSapBuExportSlice
        return startProcessKxLvmSapBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessKxLvmSapBuExport = createAsyncThunk('processKxLvmSapBuExportSlice/loadUserParamsProcessKxLvmSapBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKxLvmSapBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKxLvmSapBuExportStatus } = getState().processKxLvmSapBuExportSlice
        return loadUserParamsProcessKxLvmSapBuExportStatus !== 'pending'
    }
})

const ProcessKxLvmSapBuExportSlice = createSlice({
    name: 'processKxLvmSapBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessKxLvmSapBuExport: (state) => {
            state.job = undefined
            state.startProcessKxLvmSapBuExportError = undefined
        },
        resetstartProcessKxLvmSapBuExportError: (state) => {
            state.startProcessKxLvmSapBuExportError = undefined
        },
        resetloadUserParamsProcessKxLvmSapBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKxLvmSapBuExportError = undefined
        },
        resetloadUserParamsProcessKxLvmSapBuExportError: (state) => {
            state.loadUserParamsProcessKxLvmSapBuExportError = undefined
        },
        removeFromProcessKxLvmSapBuExportListById: (state, action) => {
            state.processKxLvmSapBuExportList = state.processKxLvmSapBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKxLvmSapBuExportListByIds: (state, action) => {
            state.processKxLvmSapBuExportList = state.processKxLvmSapBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKxLvmSapBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKxLvmSapBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKxLvmSapBuExportList = []
            state.startProcessKxLvmSapBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKxLvmSapBuExport.pending, (state) => {
            state.startProcessKxLvmSapBuExportStatus = 'pending'
            state.startProcessKxLvmSapBuExportError = undefined
        })
        builder.addCase(startProcessKxLvmSapBuExport.fulfilled, (state, action) => {
            state.startProcessKxLvmSapBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKxLvmSapBuExport.rejected, (state, action) => {
            state.startProcessKxLvmSapBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKxLvmSapBuExportError = action.error.message
            } else {
                state.startProcessKxLvmSapBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKxLvmSapBuExport.pending, (state) => {
            state.loadUserParamsProcessKxLvmSapBuExportStatus = 'pending'
            state.loadUserParamsProcessKxLvmSapBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessKxLvmSapBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessKxLvmSapBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKxLvmSapBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessKxLvmSapBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKxLvmSapBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessKxLvmSapBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKxLvmSapBuExport,
    resetstartProcessKxLvmSapBuExportError,
    resetloadUserParamsProcessKxLvmSapBuExport,
    resetloadUserParamsProcessKxLvmSapBuExportError,
    removeFromProcessKxLvmSapBuExportListById,
    removeFromProcessKxLvmSapBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKxLvmSapBuExportSlice.actions
export default ProcessKxLvmSapBuExportSlice.reducer
